import styled from "styled-components";
import { pxToRem } from "../../styles/utils";

export const StatWindowContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: start;
  box-sizing: border-box;
  border: ${pxToRem(1)} solid rgba(31, 10, 53, 0.1);
  border-radius: ${pxToRem(16)};
  box-shadow: 0px 0px 0px ${pxToRem(6)} rgba(31, 10, 53, 0.05);
  background: rgb(255, 255, 255);
`;

export const StatWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: start;
  padding: ${pxToRem(16)};
`;

export const StatTitle = styled.div`
  font-size: ${pxToRem(18)};
  font-weight: 500;
  color: #1f0a35;
  text-align: center;
`;

export const StatNumber = styled.div`
  font-size: ${pxToRem(36)};
  font-weight: bold;
  color: #1f0a35;
`;

export const StatButton = styled.button`
  padding: ${pxToRem(14)} ${pxToRem(28)};
  border-radius: ${pxToRem(10)};
  background: rgba(114, 82, 220, 0.1);
  color: rgb(114, 82, 220);
  font-size: ${pxToRem(16)};
  font-weight: 600;
  border: none;
  cursor: pointer;
  width: 100%;
`;

export const ButtonWrapper = styled.div`
  margin-top: auto;
  width: 100%;
  display: flex;
  justify-content: center;
  padding: ${pxToRem(8)};
`;
